import { TextV2 } from '@withjoy/joykit';
import React from 'react';
interface ContentProps {
  title: string;
  message?: string;
  children: React.ReactNode;
}

export const Content = (props: ContentProps) => {
  const { title, message, children } = props;
  return (
    <>
      <TextV2
        typographyVariant="hed6"
        textAlign="center"
      >
        {title}
      </TextV2>
      {message && (
        <TextV2
          typographyVariant="body1"
          marginTop={4}
          width={274}
          textAlign="center"
        >
          {message}
        </TextV2>
      )}

      {children}
    </>
  );
};
